import React, { useState } from 'react';
import { motion } from 'framer-motion';
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";


export const ImageGallery = ({ images }) => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const [open, setOpen] = React.useState(false);
  const [index, setIndex] = React.useState(0);


  const handleThumbnailClick = (index) => {
    setCurrentImageIndex(index);
  };


  if (!images) return ""

  return (
    <div className="image-gallery">
      <div className="large-image">
        <motion.img
          src={images[currentImageIndex].image.asset.url}
          alt={images[currentImageIndex].title}
          className="cursor-pointer"
          onClick={() => { setOpen(true); setIndex(index) }}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5 }}
        />
      </div>
      {images.length > 1 &&
        <div className="thumbnails flex space-x-2 mt-4">
          {images.map((image, index) => (
            <motion.img
              key={"thubmnail" + index}
              src={image.image.asset.url}
              alt={image.title}
              className="w-24 h-24 object-cover cursor-pointer"
              onClick={() => handleThumbnailClick(index)}
              transition={{ duration: 0.2 }}
            />
          ))}
        </div>
      }
    <Lightbox
        index={index}
        open={open}
        close={() => setOpen(false)}
        slides={
          images.map((image) => {
            return { src: image.image.asset.url }
          })
        }
      />
    </div>
  );
};
